import React, { useEffect, useState } from 'react'
import { Card, Typography, Button } from '@mui/material'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useNavigate } from 'react-router-dom';

const SignUpQuestionsSetup = () => {
    const [seconds, setSeconds] = useState(6);
    const Navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            return Navigate('/dashboard')
        }, 6000);

    }, []);
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            // slidesToSlide: 3 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            // slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            // slidesToSlide: 1 // optional, default to 1.
        }
    };
    const jsonOutput = [{
        title: "How to deal with depression",
        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXLBYMyLtHTyo38LKFwiLj0FfNZTKkQqBhGntgb71jwcN_CK3_ltgVoi-zzSzL7Vt03GM&usqp=CAU"
    }, {
        title: "How to deal with depression",
        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXLBYMyLtHTyo38LKFwiLj0FfNZTKkQqBhGntgb71jwcN_CK3_ltgVoi-zzSzL7Vt03GM&usqp=CAU"
    }, {
        title: "How to deal with depression",
        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXLBYMyLtHTyo38LKFwiLj0FfNZTKkQqBhGntgb71jwcN_CK3_ltgVoi-zzSzL7Vt03GM&usqp=CAU"
    }, {
        title: "How to deal with depression",
        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXLBYMyLtHTyo38LKFwiLj0FfNZTKkQqBhGntgb71jwcN_CK3_ltgVoi-zzSzL7Vt03GM&usqp=CAU"
    }]

    return (
        <div style={{
            width: '40%',
            padding: '5% 30%'
        }}>
            <Carousel

                swipeable={false}
                draggable={false}
                showDots={true}
                responsive={responsive}
                // means to render carousel on server-side.
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={1000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                // deviceType={this.props.deviceType}
                dotListClass="custom-dot-list-style"
            // itemClass="carousel-item-padding-40-px"
            >
                {
                    jsonOutput.map((data, i) => (
                        <Card key={i} style={{
                            padding: '8% 0'
                        }}>

                            <img width="100%" src={data.src} />

                        </Card>

                    ))
                }



            </Carousel>
            <Typography style={{
                //styleName: Sub Heading 1;
                fontFamily: "Satoshi",
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "24px",
                letterSpacing: "0em",
                textAlign: "center"

            }}>
                Setting up everything you need in your journey to better mental health
            </Typography>
        </div >
    )
}

export default SignUpQuestionsSetup